var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_VOTE_WINNER } from "../actions/setVoteWinner";
var initialState = {
    isThereWinner: false,
};
export function getVoteWinner(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_VOTE_WINNER:
            return __assign(__assign({}, state), { isThereWinner: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getVoteWinner.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_VOTE_WINNER } from "../actions/setVoteWinner";
var initialState = {
    isThereWinner: false,
};
export function getVoteWinner(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_VOTE_WINNER:
            return __assign(__assign({}, state), { isThereWinner: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getVoteWinner.js.map